module.exports = "<div class=row> <div class=\"col s12\"> <h4 class=header>Methods</h4> <table class=highlight> <thead> <tr> <th>Name</th> <th>Parameters</th> <th>Returns</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"method in data\"> <td>{{method.name}}</td> <td>{{method.parameters}}</td> <td>{{method.returns}}</td> <td>{{method.description}}</td> </tr> </tbody> </table> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/components/methods.vue
 ** module id = 378
 ** module chunks = 0
 **/